export const HUBSPOT_PORTAL_ID = '43762772';
export const HUBSPOT_SCRIPT_URL = '//js.hsforms.net/forms/embed/v2.js';
export const HUBSPOT_REGION = 'na1';

export const hubspotForms: Record<string, string> = {
  'submit-a-pac': '85d6d866-dde7-4c65-9420-350cb0be113a',
};
